// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

import "prismjs/themes/prism.css"

import "./src/pages/style.css"
import "./src/pages/top.css"
import "./src/pages/staff.css"
import "./src/pages/overview.css"
import "./src/pages/catalog.css"
